import { SiteUrls } from '@tableau/shared-urls';
import { ButtonType, DialogFooterButtonsWidget, DialogPositioningBehavior, DialogProps, DialogType, DialogWidget } from '@tableau/widgets';
import React from 'react';

import { Location} from '~commonInfra/utils/Location';
import { SessionUserSelectors } from '~src/bootstrap/redux/selectors/SessionInfoSelectors';
import { getAppStore } from '~src/bootstrap/redux/store/AppStore';
import { Messages } from '~src/codegen/Localize';
import { WebHttpClientWithErrorToastInstance } from '~src/httpClient/WebHttpClientWithErrorToast';
import { getSessionManagementServiceInstance } from '~src/sessionManagement/SessionManagementService';
import { UpdateDataManagementAwarenessRequest } from '~src/userSettings/serverApi/requests/UpdateDataManagementAwarenessRequest';

import { CloseAndDismiss, ReactModalService } from '../../dialogs/ReactModalService';
import { TabDialogWidth } from '../../dialogs/style/TabDialogWidth';
import { HelpService } from '../../services/HelpService';
import { imgPath } from '../../utils/ImgUrl';
import { dqwImage, dqwImageContent, dqwTextContent, dqwWrapper, getListWrapper,header } from './DMAwarenessStyles';
import { DMAwarenessInExploreActionPlaces, DMAwarenessInExploreActions, sendDMAwarenessTelemetry } from './DMAwarenessTelemetry';
import { showDisableDataManagementAwarenessToast } from './DmAwarenessUtils';



function GetDialogWidget(dialogProps: DialogProps) {
    let helpText: Array<JSX.Element> = [];
    let helpTextList = [
        Messages.lineageInformationalListItem1(),
        Messages.lineageInformationalListItem2(),
        Messages.lineageInformationalListItem3(),
        Messages.lineageInformationalListItem4(),
    ];
    helpTextList.forEach(
        (element) => { helpText.push(<li>{element}</li>); }
    );
    sendDMAwarenessTelemetry(
        DMAwarenessInExploreActions.ViewDMAwarenessFeature,
        DMAwarenessInExploreActionPlaces.DQW);
    return (
        <DialogWidget {...dialogProps}>
            <div className={dqwWrapper}>
                <div className={dqwImageContent}>
                    <div>
                        <img className={dqwImage} alt={Messages.dqwInformationContentHeader()} src={imgPath('dqw_preview.png')} />
                    </div>
                </div>
                <div className={dqwTextContent}>
                    <div className={header}>{Messages.dqwInformationContentHeader()}</div>
                    <div>{Messages.dqwInformationalListLabel()}</div>
                    <ul className={getListWrapper()}>
                        {helpText}
                    </ul>
                </div>
            </div>
        </DialogWidget>
    );
}

export function dqwPreviewDialog(siteUrls?: SiteUrls) {

    ReactModalService.openCustom(closeAndDismiss => {

        const dialogProps = ReactModalService.getDefaultDialogProps({
            type: DialogType.NormalWithTitleBar,
            title: Messages.dqwInformationContentDialogHeading(),
            testId: 'dqw-preview-dialog',
            showCloseButton: true,
            positioningBehavior: DialogPositioningBehavior.Centered,
            dialogWidth: TabDialogWidth.width900px,
            footerContent: GetFooterContent(closeAndDismiss, siteUrls),
            dialogHeight: 520
        }, closeAndDismiss);

        return GetDialogWidget(dialogProps);
    });
}

const onDismiss = (closeAndDismiss: CloseAndDismiss, siteUrls: SiteUrls) => {
    const currentUser = getSessionManagementServiceInstance().sessionUserInfo();
    const url = siteUrls.userSettingsUrl(currentUser.username, currentUser.domainName);
    WebHttpClientWithErrorToastInstance.sendRequestAndDelay(
        new UpdateDataManagementAwarenessRequest({
            user:currentUser.id,
            prepConductorAwarenessEnabled:SessionUserSelectors.showPrepConductorAwareness(getAppStore().getState()),
            catalogAwarenessEnabled: false
        })).then(() => {
            getSessionManagementServiceInstance().refreshSessionInfo();
            closeAndDismiss.close();
            Location.instance.setUrl(siteUrls.datasourcesUrl());
        });
        showDisableDataManagementAwarenessToast(url);
        sendDMAwarenessTelemetry(
            DMAwarenessInExploreActions.HideAction,
            DMAwarenessInExploreActionPlaces.DQW);
        };


function GetFooterContent(closeAndDismiss: CloseAndDismiss, siteUrls?: SiteUrls) {

    return (
        <>
            <DialogFooterButtonsWidget
                buttons={[
                    {
                        handleClick: () => {
                            sendDMAwarenessTelemetry(
                                DMAwarenessInExploreActions.LearnMoreAction,
                                DMAwarenessInExploreActionPlaces.DQW);
                                window.open(HelpService.getHelpUrlByCategory('server-dmaware-dqw-cloud'), '_blank');
                        },
                        buttonType: ButtonType.Primary,
                        children: Messages.learnMore(),
                        testId: 'footer-discard',
                    },
                    {
                        handleClick: () => {
                            onDismiss(closeAndDismiss, siteUrls);
                        },
                        buttonType: ButtonType.LowEmphasis,
                        children: Messages.flowSchedulesInformationalNoThanks(),
                        testId: 'footer-copy',
                    }
                ]}
                testId='footer'
            />
        </>
    );
}